import n, { useState as y, useRef as N, useMemo as $, useEffect as W } from "react";
import l from "classnames";
import { mintelGray300 as J, mintelWhite as Q, mintelGray400 as Y } from "mintel-tokens";
import { u as ee } from "../utils-C0l876fA.es.js";
import { u as te } from "../ThemeProvider--i7ESlT5.es.js";
import { u as ne } from "../DarkModeProvider-xoZXm3ct.es.js";
import { I as oe } from "../InputError-I0ejYOQJ.es.js";
import { I as ce } from "../InputLabel-CinetSzC.es.js";
import { I as O } from "../Icon-BuIPTPJn.es.js";
import { t as re } from "../utils-Ci4OZEP4.es.js";
import { w as ae } from "../withTheme-zx3wTAWo.es.js";
import { w as le } from "../context-B284KgoM.es.js";
import '../index7.css';const ue = "1.125rem", _e = "1.25rem", se = "TextInput-compere-module__container___oZCWu", ie = "TextInput-compere-module__inTextInputSelectWrapper___CRBzV", me = "TextInput-compere-module__inTextInputSelect___E2gin", Ie = "TextInput-compere-module__absoluteRight___95yHr", pe = "TextInput-compere-module__absoluteLeft___S6pd-", de = "TextInput-compere-module__clearIcon___bLvwF", fe = "TextInput-compere-module__invisible___XIIAr", xe = "TextInput-compere-module__label___AnLts", Te = "TextInput-compere-module__required___zBKYP", he = "TextInput-compere-module__input___VUaNe", be = "TextInput-compere-module__errorOutline___jm0U5", Se = "TextInput-compere-module__dark___VLiCH", $e = "TextInput-compere-module__disabled___-D5RS", ge = "TextInput-compere-module__hasActionIconLeft___2-fbD", Re = "TextInput-compere-module__hasActionIconRight___B4jzz", Le = "TextInput-compere-module__hasClearIcon___qBpu5", ve = "TextInput-compere-module__actionIcon___gmyVx", ze = {
  actionIconSize: ue,
  clearIconSize: _e,
  container: se,
  inTextInputSelectWrapper: ie,
  inTextInputSelect: me,
  absoluteRight: Ie,
  absoluteLeft: pe,
  clearIcon: de,
  invisible: fe,
  label: xe,
  required: Te,
  input: he,
  errorOutline: be,
  dark: Se,
  disabled: $e,
  hasActionIconLeft: ge,
  hasActionIconRight: Re,
  hasClearIcon: Le,
  actionIcon: ve
}, Ce = "1.125rem", Ee = "1.25rem", Ae = "TextInput-default-module__container___9WBqZ", ke = "TextInput-default-module__inTextInputSelectWrapper___Xe-Bi", ye = "TextInput-default-module__inTextInputSelect___holP7", Ne = "TextInput-default-module__absoluteRight___23w7U", We = "TextInput-default-module__absoluteLeft___44yHG", Oe = "TextInput-default-module__clearIcon___7db6-", qe = "TextInput-default-module__invisible___Nuzse", we = "TextInput-default-module__label___3224y", Me = "TextInput-default-module__required___6X-3l", Xe = "TextInput-default-module__input___Adrc4", Ge = "TextInput-default-module__errorOutline___XmhS0", Ue = "TextInput-default-module__dark___-ce3X", je = "TextInput-default-module__disabled___kGL5u", Be = "TextInput-default-module__hasActionIconLeft___US9RA", De = "TextInput-default-module__hasActionIconRight___33gVD", Fe = "TextInput-default-module__hasClearIcon___41QC1", He = "TextInput-default-module__actionIcon___ajTVJ", q = {
  actionIconSize: Ce,
  clearIconSize: Ee,
  container: Ae,
  inTextInputSelectWrapper: ke,
  inTextInputSelect: ye,
  absoluteRight: Ne,
  absoluteLeft: We,
  clearIcon: Oe,
  invisible: qe,
  label: we,
  required: Me,
  input: Xe,
  errorOutline: Ge,
  dark: Ue,
  disabled: je,
  hasActionIconLeft: Be,
  hasActionIconRight: De,
  hasClearIcon: Fe,
  actionIcon: He
}, Ve = {
  compere: ze,
  default: q
}, Ke = (o, p, c = !1) => o && document.activeElement !== p.current ? c ? J : Q : Y, Pe = (o) => o === "password" ? "text" : o, Ze = (o) => ["decimal", "numeric"].includes(o) ? "number" : o, Je = ({
  inTextInputSelect: o,
  className: p,
  disabled: c,
  error: u,
  focused: d,
  icon: f = {
    name: "search",
    disabled: !1,
    label: "search"
  },
  iconAlign: _ = "left",
  id: g,
  ariaDescribedBy: x,
  ariaLabelledBy: T,
  label: s,
  showLabel: w,
  name: M,
  onBlur: X = () => [],
  onChange: G = () => [],
  onClear: U = () => [],
  onFocus: j = () => [],
  onSubmit: h = () => [],
  password: B,
  placeholder: D,
  showClear: R = !0,
  autoComplete: F,
  showIcon: m = !0,
  size: H,
  style: V,
  value: a,
  required: L,
  type: v = "text"
}) => {
  const K = te(), I = ne(), { t: P } = ee(), e = Ve[K] || q, [b, S] = y(a ?? ""), [Z, z] = y(!1), C = N(a), r = N(null), E = $(
    () => Ke(I, r, c),
    // dependent on resetIconColor because document.activeElement changes do not trigger re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [I, c, r, Z]
  );
  W(() => {
    d && !c && r.current && (r.current.focus(), r.current.select());
  }, [d, c]), W(() => {
    a !== C.current && (C.current = a, S(a ?? ""));
  }, [a]);
  const A = /* @__PURE__ */ n.createElement(
    "button",
    {
      className: l(
        e.actionIcon,
        _ === "left" && e.absoluteLeft
      ),
      onClick: () => {
        h && h({ target: r });
      },
      "aria-label": f.label,
      disabled: !!f.disabled,
      type: "button"
    },
    /* @__PURE__ */ n.createElement(O, { name: f.name, size: e.actionIconSize, color: E })
  ), i = $(
    () => g ?? (s ? re(s) : void 0),
    [g, s]
  ), k = $(() => {
    const t = x ?? T ?? i;
    return t ? `${t}-error-message` : "";
  }, [x, T, i]);
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: l(
        o && e.inTextInputSelectWrapper
      )
    },
    w && i && /* @__PURE__ */ n.createElement(
      ce,
      {
        label: s,
        dark: I,
        inputId: i,
        required: L
      }
    ),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        className: l({
          [e.errorOutline]: !!u
        })
      },
      /* @__PURE__ */ n.createElement("div", { className: l(e.container, p), style: V }, m && _ === "left" && A, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: B ? "password" : Ze(v),
          inputMode: Pe(v),
          ref: r,
          name: M,
          id: i,
          "aria-invalid": !!u,
          "aria-describedby": `${k ?? ""} ${x ?? ""}`,
          "aria-labelledby": T,
          "aria-label": s,
          className: l(
            e.input,
            m && _ === "left" && e.hasActionIconLeft,
            m && _ === "right" && e.hasActionIconRight,
            R && e.hasClearIcon,
            u && e.errorOutline,
            o && e.inTextInputSelect,
            c && e.disabled,
            I && e.dark
          ),
          onBlur: (t) => {
            X(t), z(!1);
          },
          onFocus: (t) => {
            j(t), z(!0);
          },
          onChange: (t) => {
            S(t.target.value), G(t);
          },
          value: b,
          placeholder: D,
          onKeyDown: (t) => {
            t.key === "Enter" && h(t);
          },
          disabled: c,
          autoFocus: d,
          size: H,
          required: L,
          autoComplete: F
        }
      ), /* @__PURE__ */ n.createElement("span", { className: e.absoluteRight }, R && /* @__PURE__ */ n.createElement(
        "button",
        {
          className: l(
            e.clearIcon,
            !b && e.invisible
          ),
          onClick: () => {
            S(""), U();
          },
          disabled: !b,
          type: "button",
          "aria-label": P("clear")
        },
        /* @__PURE__ */ n.createElement(
          O,
          {
            name: "close",
            size: e.clearIconSize,
            color: E
          }
        )
      ), m && _ === "right" && A))
    ),
    u && /* @__PURE__ */ n.createElement(oe, { id: k }, u)
  );
}, st = le(ae(Je));
export {
  st as default
};
